// R5-9 — THE MASTER-NUMBER LAW, LIFTED OUT OF App.tsx VERBATIM.
//
// Digit reduction stops at 11, 22 and 33. A reduction that quietly takes 11 down to 2 produces a
// wrong reading with no error anywhere on the screen — the member is simply told she is a 2 when she
// is an 11. That is why this is a gated law and not an inline expression: `scripts/r5-extraction.mjs`
// runs it against every master number and a real birth date.
//
// The engine on the server is the answer key for the numerology ROOM; this is the client-side
// life-path shown beside a chart, and the two must agree on the master numbers.

export function reduceNumber(value: number) {
  let current = Math.abs(value);

  while (current > 9 && current !== 11 && current !== 22 && current !== 33) {
    current = String(current)
      .split("")
      .reduce((sum, digit) => sum + Number(digit), 0);
  }

  return current;
}

export function lifePathFromDate(date: string) {
  const total = date.replace(/\D/g, "").split("").reduce((sum, digit) => sum + Number(digit), 0);
  return total ? String(reduceNumber(total)) : "Awaiting birth date";
}
